import { IconProps } from "@/data/types"

export default function ArrowLeftIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.6057 10.0001H1.39254M1.39254 10.0001L10.0104 18.618M1.39254 10.0001L10.0104 1.38222" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}